module.exports = __webpack_public_path__ + "img/conference.1000e6dd.jpg";